import type { Role } from '../types/scoreboard';

const RED_ROLES = new Set<Role>(['мирный', 'шериф']);

export function isWinningRole(role: Role, winnerTeam: 'red' | 'black'): boolean {
  const isRed = RED_ROLES.has(role);
  return (isRed && winnerTeam === 'red') || (!isRed && winnerTeam === 'black');
}

// Base scoring per the club rules: win = 1.3, loss = 0.3. Bonuses/penalties
// (best move, judge points, fouls) are added manually on top by the admin.
export function basePoints(role: Role, winnerTeam: 'red' | 'black'): string {
  return isWinningRole(role, winnerTeam) ? '1.3' : '0.3';
}
